import { baseURL } from './http.js';
import request from './request.js';
export default {
  getUserList: item => request(baseURL).post('/cUser/list', item),
  getUserListAll: item => request(baseURL).post('/cUser/listAll', {...item, isEnable: '1', }),
  getUserListBuyer: item => request(baseURL).post('/cUser/listBuyer', {...item, isEnable: '1', }),
  getCUser: val => request(baseURL).get(`/cUser/get?id=${val}`),
  getByCode: val => request(baseURL).get(`/supplier/getByCode?code=${val}`),
  getSupplierList: item => request(baseURL).post('/supplier/list', item),
  getSupplierUserList: item => request(baseURL).post('/supplier/listSelectItem', item),
  getAllSupplierList: item => request(baseURL).post('/supplier/listAll', item),
  getUserSupplierRelation: item => request(baseURL).post('/userSupplierRelation/list', item),
  getListAllByUserId: val => request(baseURL).get(`userSupplierRelation/listAllByUserId?userId=${val}`),
  batchCreateUserSupplierRelation: item => request(baseURL).post('userSupplierRelation/batchCreate', item),
  deleteByUserId: item => request(baseURL).post('userSupplierRelation/deleteByUserId', item),
  getCountry: item => request(baseURL).post('country/listAll', item),
  getListAllCommonCountry: item => request(baseURL).post('country/listAllCommonCountry', item),
  getSignedUrl: val => request(baseURL).post(`file/getSignedUrl?filePath=${val}`),
  updateBrand: item => request(baseURL).post('cUser/updateBrand', item),
  getCUserBrand: item => request(baseURL).get(`cUser/get?id=${item}`),
};